import { TableCard } from '../../../../components'
import { FormularioHeading } from '../formularios-create/component/FormularioHeading'
import { EspecialidadeVinculosListHeader } from './components/header/EspecialidadeVinculosListHeader'
import { ListFiltersProvider } from './core/ListFiltersProvider'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { EspecialidadeVinculosTable } from './table/EspecialidadeVinculosTable'

const EspecialidadeVinculosList = () => (
  <>
    <FormularioHeading />
    <TableCard>
      <EspecialidadeVinculosListHeader />
      <EspecialidadeVinculosTable />
    </TableCard>
  </>
)

export const EspecialidadeVinculosListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListFiltersProvider>
        <EspecialidadeVinculosList />
      </ListFiltersProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)
